import ActiviteCommercial from '@/views/ActiviteCommercial.vue'
import ClientsPage from '@/views/Clients.vue'
import KpiChiffresDaffaires from '@/views/KpiChiffresDaffaires.vue'
import PerformancesFinancierePage from '@/views/PerformancesFinanciere.vue'
import RepartitionDesFormations from '@/views/RepartitionDesFormations.vue'
import SuiviCommandesPage from '@/views/SuiviDesCommandes.vue'
import TableauDeBord from '@/views/TableauDeBord.vue'
import { createRouter,createWebHashHistory, createWebHistory } from 'vue-router'

const history = import.meta.env.PROD ? createWebHashHistory() : createWebHistory(import.meta.env.BASE_URL);

const router = createRouter({
  history: history,
  routes: [
    {
      path: '/',
      name: 'Tableau de bord',
      component: TableauDeBord,
    },
    {
      path: '/kpi-chiffres-affaires',
      name: "KPI chiffres d'affaires",
      component: KpiChiffresDaffaires,
    },
    {
      path: '/clients',
      name: 'Clients',
      component: ClientsPage,
    },
    {
      path: '/performances-financiere',
      name: 'Performances financière',
      component: PerformancesFinancierePage,
    },
    {
      path: '/suivi-des-commandes',
      name: 'Suivi des commandes',
      component: SuiviCommandesPage,
    },
    {
      path: '/activite-commercial',
      name: 'Activité commercial',
      component: ActiviteCommercial,
    },
    {
      path: '/repartition-des-formations',
      name: 'Répartition des formations',
      component: RepartitionDesFormations,
    },
  ],
})

export default router
